import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { ButtonLoadable } from '@/components/ui/button-loadable';
import { SupportModal } from '@/modules/common/components/modals/support-modal';
import { FullPageErrorState } from '@/modules/common/components/organisms/full-page-error-state';

interface AuthenticatedErrorProps {
  onRetry: () => void;
  isLoading: boolean;
}

/**
 * Full-screen error page for authenticated (non-onboarding) users
 * when the onboarding flow API fails during initial route resolution.
 */
export const AuthenticatedError: React.FC<AuthenticatedErrorProps> = ({ onRetry, isLoading }) => {
  const { t } = useTranslation('common');

  return (
    <FullPageErrorState
      title={t('error.accountLoadFailed')}
      description={t('error.accountLoadFailedMessage')}
      showLogoutButton
      actions={
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <ButtonLoadable variant="outline" onClick={onRetry} isLoading={isLoading} showRefreshIcon>
            {t('error.refresh')}
          </ButtonLoadable>
          <SupportModal hideForm>
            <Button variant="default">{t('contactSupport')}</Button>
          </SupportModal>
        </div>
      }
    />
  );
};
